import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_CURRENCIES } from "@/redux/constants/parameters";

const getCurrencies = sharedService.injectEndpoints({
  endpoints: builder => ({
    getCurrencies: builder.query({
      query: () => "parameters/currencies",
      transformResponse: response => response.items,
      providesTags: ["Currencies"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_CURRENCIES, currencies: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetCurrenciesQuery } = getCurrencies;

